
import { Component, Vue, Watch } from 'vue-property-decorator';
import PersonData from '@/ts/PersonData';
import { Mutations } from '@/ts/store/Constants';
import store from '@/store';
@Component({
})
export default class UserMethods extends Vue {
    // Computed properties
    get firm(): string {
        return store.getters['User/getUser'].firm;
    }

    // Is employee
    get isEmployee(): boolean {
        return store.getters['User/isEmployee'];
    }

    // Profile image
    get profileImage(): string {
        return store.getters['User/getUser'].profileImage;
    }

    // Associated users
    get associatedUsers(): PersonData[] {
        return store.getters['User/getAssociatedUsers'];
    }

    // Address
    get address(): string {
        return store.getters['User/getUser'].address;
    }

    set address(value: string) {
        store.commit(Mutations.UPDATE_ADDRESS, value);
        return;
    }

    // Name 
    get name(): string {
        return store.getters['User/getUser'].fullName;
    }

    // First name
    get firstName(): string {
        return store.getters['User/getUser'].firstName;
    }

    set firstName(value: string) {
        store.commit(Mutations.UPDATE_FIRST_NAME, value);
        return;
    }

    // Family name
    get familyName(): string {
        return store.getters['User/getUser'].familyName;
    }

    set familyName(value: string) {
        store.commit(Mutations.UPDATE_FAMILY_NAME, value);
        return;
    }

    // Email
    get email(): string {
        return store.getters['User/getUser'].email;
    }
    // get email(): string {
    //     return store.getters['User/getEmail'];
    // }

    set email(value: string) {
        store.commit(Mutations.UPDATE_EMAIL, value);
        return;
    }

    // Country
    get country(): string {
        return store.getters['User/getUser'].country;
    }

    set country(value: string) {
        store.commit(Mutations.UPDATE_COUNTRY, value);
        return;
    }

    // Zip-code
    get zipcode(): string {
        return store.getters['User/getUser'].zipCode;
    }

    set zipcode(value: string) {
        store.commit(Mutations.UPDATE_ZIPCODE, value);
        return;
    }

    // City
    get city(): string {
        return store.getters['User/getUser'].city;
    }

    set city(value: string) {
        store.commit(Mutations.UPDATE_CITY, value);
        return;
    }

    // Phone number
    get formattedNumber(): string {
        return store.getters['User/getUser'].formattedNumber;
    }

    get phoneNumber(): number {
        return store.getters['User/getUser'].phoneNumber;
    }

    set phoneNumber(value: number) {
        store.commit(Mutations.UPDATE_PHONENUMBER, value);
        return;
    }

    get propertyArea(): number {
        return store.getters['User/getUser'].residentPropertyData.area;
    }

    get propertyRooms(): number {
        return store.getters['User/getUser'].residentPropertyData.rooms;
    }

    get propertyEnergyRating(): string {
        if (store.getters['User/getUser'].residentPropertyData.energyRating === null) {
            return '';
        }

        return store.getters['User/getUser'].residentPropertyData.energyRating;
    }

    get propertyRent(): number {
        return store.getters['User/getUser'].residentPropertyData.rent;
    }   

    get propertyDeposit(): number {
        return store.getters['User/getUser'].residentPropertyData.deposit;
    }    

    get projectDescription(): string {
        return store.getters['User/getUser'].residentPropertyData.projectDescription;
    }

    get mainRole(): string {
        return this.$store.getters['User/getUser'].mainRole;
    }

    public hasFeatureAccess(feature: string) {
        return store.getters['User/getUser'].features.includes(feature);
    }
}
